import script from "./ContactDataModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactDataModal.vue?vue&type=script&setup=true&lang=ts"

import "./ContactDataModal.vue?vue&type=style&index=0&id=74fb1780&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fb1780"]])

export default __exports__